import React from 'react';

import { useEditorTabStateSelector } from 'src/editor/editor-tab-state-registry';
import { useEditingHooks } from 'src/editor/helpers/useEditingHooks';
import { ClientTransforms } from 'src/editor/transforms';
import { useAuthorizedTransforms } from 'src/hooks';

import { GenericColorSelect } from '../shared/GenericColorSelect';

export const TableCellFillSelect = React.memo(function TableCellFillSelect(): JSX.Element {
  const { AuthorizedTransforms } = useAuthorizedTransforms();
  const { authorId, editingMode, editor, editorLoading } = useEditingHooks();
  const fillColor = useEditorTabStateSelector(
    state => state.derived.tableCellProperties.shade?.fillColor
  );

  const selectColor = (color: string | null) => {
    if (!authorId || !editingMode) return;

    AuthorizedTransforms.setTableCellProps(editor, {
      authorId,
      editingMode,
      props: {
        shade: typeof color == 'string' ? { fillColor: color } : undefined,
      },
    });
    ClientTransforms.focus(editor);
  };

  return (
    <GenericColorSelect
      color={fillColor ?? null}
      editorLoading={editorLoading}
      hasTransparentOption={true}
      iconType="fill"
      tooltipTitle="Cell fill color"
      onSelectColor={selectColor}
    />
  );
});
